/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState, useRef } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Formik, Form , Field} from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import { isProduction } from 'src/config/index';
import PropTypes from 'prop-types';
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import Table from 'src/components/table/Table';
import { caseResetAction, caseSearchAction } from '../case-container/actions/CaseActions';
import { headerShowAction } from '../header-container/actions/HeaderActions';
import { PAYMENT_MODE_TYPES_LIST } from '../product-container/ProductConstants';
import FormikSelect from 'src/components/formik/FormikSelect';
import { caseInvoiceCreateAPI, casePaymentCreateAPI } from 'src/api/CaseApi';
import { useHistory, useParams } from 'react-router';
import FormikInput from 'src/components/formik/FormikInput';
import { useEffect } from 'react';
import { PaymentYupSchema } from './TransactionPropTypes';
// import { ExportReactCSV } from 'src/components/excel/ExportReactCSV';


const RenderFilters = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        // errors,
        // touched,
        isSubmitting,
        onClear,
        // forceRefreshSearchContainer,
        resetForm,
        values,
        activityList,
        userType,
        ExportInExcel,
        handleChange,
        generateInvoice,
        comissionManager,
        history,
    } = props;

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Add New Payment</h5>
                    <Form>
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label>Mode of Payment</label>
                                <FormikSelect
                                    items={PAYMENT_MODE_TYPES_LIST}
                                    name="mode"
                                    className="form-control"
                                />
                                {/* <Field
                                    type="text"
                                    className="form-control"
                                    disabled
                                    value="NEFT/RTGS"
                                    name="mode"
                                    initialValue="NEFT_RTGS"
                                /> */}
                            </div>
                            <div className="form-group col-md-4">
                                <label>Payment Date</label>
                                <FormikDateTimePicker
                                    name="date"
                                    className="form-control"
                                    disableClock
                                    format="dd-MM-y"
                                />
                            </div>

                            <div className="form-group col-md-4">
                                <label>Amount</label>
                                <FormikInput
                                    name="amount"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-md-4">
                                <label>Transaction/Ref. No.</label>
                                <FormikInput
                                    name="instrument_number"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                            <div className="form-group col-md-8">
                                <label>Remarks</label>
                                <FormikInput
                                    name="remarks"
                                    type="text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="text-center py-4 mt-3">
                            <FormikCreateSearchClear
                                isSubmitting={isSubmitting}
                                onClear={onClear}
                                resetForm={resetForm}
                                submitButtonText="Add Payment"
                                submitScope="reports.payout_calculation.search"
                            />
                        </div>
                    </Form>
                </div>
            </div>
            <div className="border-top my-3" />
            <div className="card mt-3">
                <div className="card-body">
                    <h5 className="card-title">
                        Search Results
                        {/* <ExportReactCSV csvData={ExportInExcel} fileName={"CaseStatusReport-" + new Date().toLocaleDateString()} /> */}
                    </h5>
                    <Table
                        rowDeletedCheckPath="deleted"
                        recordsPerPage={50}
                        searchData={{
                            data: activityList.data,
                            count: activityList.count,
                            currentPage: 0,
                        }}
                        columns={{
                            group: [
                                {
                                    display: 'Case No',
                                    path: 'caseCode',
                                },
                                {
                                    display: 'Payment Number',
                                    path: 'payment_no',
                                },
                                {
                                    display: 'Payment Date',
                                    type: Date,
                                    path: 'date',
                                },
                                {
                                    display: 'Mode of Payment',
                                    path: 'mode',
                                },
                                {
                                    display: 'Transaction/Ref. No.',
                                    path: 'instrument_number',
                                },
                                {
                                    display: 'Amount',
                                    path: 'amount',
                                },
                                {
                                    display: 'Remarks',
                                    path: 'remarks',
                                },
                            ],
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

RenderFilters.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    values: PropTypes.any.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    // activityList: PropTypes.array.isRequired,

};

// setting submit button state after submitting
const filterDefaultValues = {
    mode: 'NEFT_RTGS',
    date: '',
    amount: '',
    instrument_number: '',
    remarks: '',
};

const Payment = () => {
    
    const [
        filterInitialValues,
        setFilterInitialValues,
    ] = useState({
        ...filterDefaultValues,
    });

    const [
        currentProductCategory,
        setProductCategory,
    ] = useState();

    const [
        currentCompany,
        setCurrentCompany,
    ] = useState();

    const [
        currentActivityAssignedDateTill,
        setCurrentActivityAssignedDateTill,
    ] = useState();

    const [
        currentActivityAssignedDateFrom,
        setCurrentActivityAssignedDateFrom,
    ] = useState();

    const [
        invoiceInitialValues,
        setInvoiceInitialValues,
    ] = useState([]);

    let data = []
    // REDUX
    const dispatch = useDispatch();
    const history = useHistory();
    const { caseId } = useParams();

    const comissionManager = useRef();

    const {
        search: {
            data: searchResults,
            count,
        },
    } = useSelector((state) => state.CaseReducer, shallowEqual);

    const {
        userType
    } = useSelector((state) => state.AuthReducer, shallowEqual);
    const activitiesFromSearch = useMemo(() => {
        if (!searchResults) {
            return [];
        }
        const PrepairData = [];
        searchResults.forEach((caseInfo) => {
            const caseCode = caseInfo.caseCode;
            caseInfo.paymentDetails
              .filter((payment) => !payment.deleted) // Filter out payments where deleted is true
              .forEach((payment) => {
                PrepairData.push({
                  caseCode,
                  ...payment,
                });
              });
          });

        const results = {
            data: PrepairData,
            count
        };

        return results;
    }, [
        searchResults,
        currentProductCategory,
        currentActivityAssignedDateFrom,
        currentActivityAssignedDateTill,
        currentCompany,
        dispatch,
    ]);


    const onSubmit = useCallback(async (
        values,
        formikUtils,
    ) => {
        formikUtils.setSubmitting(false);
        const PayloadData = {
            _id: caseId,
            values
        }
        // dispatch(caseUpsertAction(PayloadData));
        casePaymentCreateAPI(caseId, PayloadData)
        let where = {
        };
        // CASEID
        if (caseId) {
            where._id = caseId;
        }
        dispatch(caseSearchAction({
            where,
            sortBy: 'ts',
            sortOrder: -1,
            fullTextSearch: false,
            pageLength: 30,
        }));
    }, [
        dispatch,
    ]);

    useEffect(() => {
        if (!caseId) {
            dispatch(headerShowAction({
                data: 'There must at least one filter to be added.',
            }));
            return;
        }

        let where = {
        };
        // CASEID
        if (caseId) {
            where._id = caseId;
        }

        dispatch(caseSearchAction({
            where,
            sortBy: 'ts',
            sortOrder: -1,
            fullTextSearch: false,
            pageLength: 30,
        }));
        return () => {

        };
    }, []);

    const onClear = useCallback(() => {
        dispatch(caseResetAction());
        setFilterInitialValues({
            ...filterDefaultValues,
        });
    }, [
        dispatch,
    ]);

    const generateInvoice = useCallback(async (commissionId) => {
        const payload = { commissionId: commissionId, data: invoiceInitialValues };
        const invoice = await caseInvoiceCreateAPI(payload);
    }, [
        invoiceInitialValues
    ]);
    const handleChange = useCallback((e) => {
        const id = e.target.name;
        const checked = e.target.value;

        if (checked == "false")
            setInvoiceInitialValues([...invoiceInitialValues, id]);
        else
            setInvoiceInitialValues(invoiceInitialValues.filter((item) => { return id !== item }));

        // setInvoiceInitialValues(id)

        // data.push(id);
        // console.log('checked', checked);
        // console.log('invoiceInitialValues=>', invoiceInitialValues);
        // if()
        // else
        // console.log('invoiceInitialValues=>', invoiceInitialValues, data);

        return data;
    }, [
        // dispatch,
        invoiceInitialValues
    ]);

    const ExportInExcel = useMemo(() => {
        if (!searchResults) {
            return [];
        }
        const results = [];
        // searchResults.forEach((caseInfo) => {
        //     let applicant = caseInfo?.applicants[0];
        //     results.push({
        //         caseCode: caseInfo.caseDetails.caseCode,
        //         CaseName: caseInfo.clientId.clientDisplayName,
        //         CaseReceiveDate: caseInfo.caseDetails.caseReceivedOn,
        //         CaseAppointmentDate: caseInfo.caseDetails.caseAppointedOn,
        //         CaseClosedDate: caseInfo.caseDetails.caseClosedOn,
        //         ProductName: caseInfo.productId.productName,
        //         ApplicationNumber: caseInfo.applicationNumber,
        //         Client: caseInfo.clientId.clientDisplayName,
        //         Branch: caseInfo.branchId.branchDisplayName,
        //         ApplicantFirstName: applicant?.personalInfo?.firstName,
        //         ApplicantLastName: applicant?.personalInfo?.lastName,
        //         ApplicantCity: applicant?.presentAddress?.cityId?.cityName,
        //     });
        // });

        return results;
    }, [
        searchResults,
        currentProductCategory,
        currentActivityAssignedDateFrom,
        currentActivityAssignedDateTill,
        currentCompany,
    ]);

    return (
        <div>

            <Formik
                onSubmit={onSubmit}
                onClear={onClear}
                enableReinitialize
                initialValues={filterInitialValues}
                validationSchema={PaymentYupSchema}
            >
                {(formikProps) => (
                    <RenderFilters
                        // forceRefreshSearchContainer={forceRefreshSearchContainer}
                        onClear={onClear}
                        {...formikProps}
                        activityList={activitiesFromSearch}
                        userType={userType}
                        ExportInExcel={ExportInExcel}
                        handleChange={handleChange}
                        generateInvoice={generateInvoice}
                        comissionManager={comissionManager}
                        history={history}
                    />
                )}
            </Formik>
        </div>
    );
};

export default Payment;
